import React from 'react';
import PostCard from './PostCard';
import './PostGrid.css';

const PostGrid = ({ posts }) => {
  if (!posts || posts.length === 0) {
    return (
      <div className="post-grid-empty">
        <p>henüz gönderi yok.</p>
      </div>
    );
  }

  return (
    <div className="post-grid">
      {posts.map(post => (
        <PostCard key={post.id} post={post} />
      ))}
    </div>
  );
};

export default PostGrid;
